import jsonapi from 'jsonapi-parse';
import Discount from '@/models/read/Discount';

export default $axios => ({ store }) => ({
    async list() {
        let response = await $axios.$get(`/api/v1/discounts`);
        let parsed = jsonapi.parse(response).data;
        if (parsed) {
            return parsed.map(d => new Discount(d));
        }

        return [];
    },
});
